
export function ClinicOverview() {
  return (
    <section id="overview" aria-labelledby="overview-heading" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-2">
            <div className="relative">
              <div className="absolute -top-8 -left-8 w-64 h-64 bg-teal-500/10 rounded-full -z-10"></div>
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/7c57aa2b-0bc3-4ea3-9148-fcea3f4fc4f0.jpg"
                  alt="Sri Maruthi Teeth Empire Dental Clinic Exterior at Botanical Garden Road, Kondapur, Hyderabad"
                  title="Sri Maruthi Teeth Empire - Dental Clinic on Botanical Garden Road Kondapur"
                  width="500"
                  height="400"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="absolute bottom-4 right-4 flex gap-3">
                <div className="w-32 h-32 rounded-2xl overflow-hidden shadow-xl border-4 border-white">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20dental%20treatment%20room%20with%20advanced%20equipment%20clean%20white%20surfaces%20teal%20accents%20professional%20lighting%20state%20of%20the%20art%20technology%20comfortable%20patient%20chair&width=200&height=200&seq=treatment-room-004&orientation=squarish"
                    alt="Advanced Dental Treatment Room at Sri Maruthi Teeth Empire Kondapur"
                    title="State-of-the-art dental treatment room at Sri Maruthi Teeth Empire"
                    width="128"
                    height="128"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="w-32 h-32 rounded-2xl overflow-hidden shadow-xl border-4 border-white">
                  <img
                    src="https://static.readdy.ai/image/4c54787fd2047152d108467e5113439e/b33050c9db6ad4c9dfed6fe857b37dbc.png"
                    alt="Expert Dental Team at Sri Maruthi Teeth Empire Kondapur Hyderabad"
                    title="Experienced dental team at Sri Maruthi Teeth Empire"
                    width="128"
                    height="128"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="inline-block bg-teal-50 px-4 py-2 rounded-full mb-4">
              <span className="text-sm font-semibold text-teal-600">About Sri Maruthi Teeth Empire Kondapur</span>
            </div>

            <h2
              id="overview-heading"
              className="text-4xl md:text-5xl font-bold mb-6 text-gray-900 leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Modern Dentistry Meets Compassionate Care in Kondapur
            </h2>

            <div className="space-y-4 text-gray-600 leading-relaxed mb-8">
              <p>
                <strong>Sri Maruthi Teeth Empire</strong> is a premier <strong>dental clinic in Kondapur, Hyderabad</strong>, located at <strong>Botanical Garden Road</strong>, dedicated to providing exceptional dental care with a patient-first approach. As the <strong>best dentist near Hitech City</strong>, our mission is to transform smiles and improve oral health through advanced technology and compassionate service.
              </p>
              <p>
                We utilize <strong>state-of-the-art dental technology</strong> and follow international standards to ensure the best outcomes for our patients. From routine cleanings to complex procedures like <strong>dental implants</strong> and <strong>root canal treatment in Kondapur</strong>, our experienced team delivers personalized treatment plans tailored to each patient&apos;s unique needs.
              </p>
              <p>
                At <strong>Sri Maruthi Teeth Empire</strong>, we believe that quality <strong>dental care in Hyderabad</strong> should be accessible, comfortable, and stress-free. Our modern facility in <strong>Kondapur</strong> is designed to create a calming environment where patients from <strong>Gachibowli, Kothaguda, Madhapur</strong>, and surrounding areas feel relaxed and confident in their treatment.
              </p>
              <p>
                With over <strong>10 years of excellence</strong> in dental care, we have built a reputation as the <strong>top-rated dental clinic near Kondapur</strong>, delivering outstanding results and maintaining the highest standards of hygiene and safety. Your smile is our priority.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="p-6 rounded-2xl text-white relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #FF6B6B 0%, #EE5A6F 100%)' }}>
                <div className="relative z-10">
                  <div className="text-5xl font-bold mb-2">98%</div>
                  <div className="text-sm font-medium">Patient Satisfaction</div>
                </div>
                <div className="absolute top-2 right-2 w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-arrow-right-up-line text-xl" aria-hidden="true"></i>
                </div>
              </div>

              <div className="p-6 rounded-2xl text-white relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #A78BFA 0%, #8B5CF6 100%)' }}>
                <div className="relative z-10">
                  <div className="text-5xl font-bold mb-2">10+</div>
                  <div className="text-sm font-medium">Years of Excellence</div>
                </div>
                <div className="absolute top-2 right-2 w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-arrow-right-up-line text-xl" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
